import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  Switch,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import MaterialSnackbar from "../../../components/MaterialSnackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BASEURL from "../../Utils/Baseurl";
import MaterialSelect from "../../../components/MasterSelect";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useUserDetails } from "../../../context/auth";
import Swal from "sweetalert2";
// import LocationPicker from "../LocationFetch/LocationPicker";

const AddWorkflow = () => {
  const navigate = useNavigate();
  const { display, setdisplay, AccessData, update, setupdate } =
    useUserDetails();

  const [id, setId] = useState(null);
  const [viewData, setViewData] = useState("");
  const [depdisplay, setdepdisplay] = useState(false);
  const [mapOpen, setMapOpen] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  let flowlist = [
    {
      label: "Leave",
      value: "leave",
    },
    {
      label: "Permission",
      value: "permission",
    },
    {
      label: "Regularization",
      value: "regularization",
    },
    {
      label: "Admin Expense",
      value: "admin_expense",
    },
    {
      label: "WFH Request",
      value: "wfh_request",
    },
    {
      label: "Reimbursement",
      value: "reimbursement",
    },
  ];

  let flowlevel = [
    {
      label: "1",
      value: 1,
    },
    {
      label: "2",
      value: 2,
    },
    {
      label: "3",
      value: 3,
    },
    {
      label: "4",
      value: 4,
    },
    {
      label: "5",
      value: 5,
    },
  ];

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [togglePage, setTogglePage] = useState({
    view: true,
    edit: true,
  });

  const [designationData, setDesignationData] = useState({
    departmentName: "",
    designationName: "",
    companyname: "",
    companynameStatus: "unchecked",
    country: "",
    countryStatus: "unchecked",
    state: "",
    stateStatus: "unchecked",
    city: "",
    cityStatus: "unchecked",
    address: "",
    addressStatus: "unchecked",
    logo: "",
    logoStatus: "unchecked",
    year: "",
    yearStatus: "unchecked",
    vessals: "",
    vessalsStatus: "unchecked",
    branch: "",
    branchStatus: "unchecked",
    latitude: "",
    latitudeStatus: "unchecked",
    longitude: "",
    longitudeStatus: "unchecked",
    Active: true,
    departmentNameStatus: "unchecked",
    designationNameStatus: "unchecked",
  });

  const [approval, setApproval] = useState({
    approvalfor: "",
    approvallevel: "",
    approvalforStatus: "unchecked",
    approvallevelStatus: "unchecked",
    hrApproval: true,
  });

  const [resource, setResource] = useState({
    departmentName: [],
  });

  const departmentOptions = [
    { value: 1, label: "Human Resources" },
    { value: 2, label: "Engineering" },
    { value: 3, label: "Marketing" },
    { value: 4, label: "Sales" },
    { value: 5, label: "Customer Support" },
  ];

  const [originalDesigntionData, setOriginalDesignationData] = useState({
    departmentName: "",
    departmentCode: "",
  });

  const [approvalfor, setapprovalfor] = useState("");
  const [approvallevel, setapprovallevel] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    onDepartmentSubmit();
    if (id) {
      getInitData(id);
    }
  }, []);

  useEffect(() => {
    onfilterData();
  }, [viewData]);

  const getInitData = async (id) => {
    const query = `query get_designation($id:String){
  getDesignationById(id:$id)
{
  id
  designation
  departmentName
}}

              `;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responsesss:", response);
      // Extract Leavetype data from the response
      const departmentRowdata = response.data.data.getDesignationById;
      const departmentNameData =
        response.data.data.getDesignationById?.departmentName;
      setViewData(departmentNameData);
      setdepdisplay(true);
      setDesignationData({
        departmentName: {
          value: departmentRowdata.departmentName,
          label: departmentRowdata.departmentName,
        },
        designationName: departmentRowdata.designation,
        // departmentNameStatus: "success",
        // designationNameStatus: "success",
      });

      setOriginalDesignationData({
        departmentName: {
          value: departmentRowdata.departmentName,
          label: departmentRowdata.departmentName,
        },
        designationData: departmentRowdata.designation,
        departmentNameStatus: "success",
        designationNameStatus: "success",
      });

      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onEditDesignationSubmit = async () => {
    const query = `  mutation ($id: String!, $designation:String!, $departmentName: String!){
    EditDesignation(id:$id, designation:$designation, departmentName:$departmentName){
      designationeditdetails{
        designation
        departmentName
        id
      }
    }
  }
`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id,
            designation: designationData.designationName,
            departmentName: designationData.departmentName.label,
          },
        }),
      });

      // const res = await axios.post(
      //     BASEURL,
      //     {
      //       query, // The query goes here
      //       variables: {
      //         id: id,
      //         designation: designationData.designationName,
      //         departmentName: designationData.departmentName.label,
      //       },
      //     },
      //     {
      //       headers: {
      //         'Content-Type': 'application/json',
      //       },
      //     }
      //   );

      console.log("response:", response.data);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Designation Updated Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/designation");
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  console.log(designationData, "designationData");

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteDesignationSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteDesignationSubmit = async () => {
    const query = `
            mutation DeleteDesignation($id: String!) {
                deleteDesignation(id: $id) {
                    success
                    message
                }
            }
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.deleteDesignation.success) {
        console.log("Designation deleted successfully!");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Designation deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/designation");
      } else {
        console.log(
          "Error deleting designation:",
          response.data.data.deleteDesignation.message
        );
      }
    } catch (error) {
      console.error("An error occurred while deleting the designation:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onDepartmentSubmit = async () => {
    const query = `query {
            allDepartment {
                id
                departmentName
                departmentCode
            }
        }`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("response:",response);

      // Extract department data from the response
      const departmentListdata = response.data.data.allDepartment;
      setResource({
        ...resource,
        departmentName: departmentListdata,
      });
      setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response departmentListdata:", departmentListdata);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const onDesignationSubmit = async () => {
    const query = `mutation Designations(
                $designation: String!
                 $departmentName: String!
              ) {
            AddDesignation(designation: $designation, departmentName: $departmentName) {
          designationdetails {
      id
      designation
      departmentName
      lastUpdate
            }
            }
           }`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            designation: designationData.designationName,
            departmentName: designationData.departmentName.label,
          },
        }),
      });

      console.log("response:", response.data);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Designation Submitted Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/designation");
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleDesignationDatachange = (event, selectEvent) => {
    console.log("selectEvent:", selectEvent, event?.label);
    let approvalState = { ...approval };

    if (event?.target === undefined && selectEvent) {
      approvalState[selectEvent.name] = event;
      approvalState[selectEvent.name+"Status"] ="success"
    }
   

    setApproval(approvalState);
  };
console.log(approval,"approval");

  const onfilterData = () => {
    const filterDepartment = resource.departmentName.filter(
      (department) => department.departmentName == viewData
    );
    console.log(
      "filterDepartment:",
      viewData,
      resource.departmentName,
      filterDepartment
    );
    console.log("display:", display);
    // setDesignationData({
    //   ...designationData,
    //   departmentName: filterDepartment.map((department) => {
    //     return {
    //       value: department.id,
    //       label: department.departmentName,
    //     };
    //   }),
    // });
  };

  const onDiscardDesignation = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

    // setDesignationData({
    //     departmentName: "",
    //     designationName: "",
    // })

    setupdate(false);
    setdepdisplay(true);
  };

  const handleAddDesignation = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDesignationSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
    setupdate(true);
    setdepdisplay(false);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      designationData.departmentNameStatus === "success" &&
      designationData.designationNameStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      designationData.departmentName ===
        originalDesigntionData.departmentName &&
      designationData.designationName === originalDesigntionData.designationName
    ) {
      allowSubmit = false;
    } else if (
      designationData.departmentName !== originalDesigntionData.departmentName
    ) {
      if (designationData.departmentNameStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (
      designationData.designationName !== originalDesigntionData.designationName
    ) {
      if (designationData.designationNameStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  console.log(togglePage);

  const generateCalendarYears = () => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5; // Adjust range as needed
    const endYear = currentYear + 5;

    return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
      const year = startYear + i;
      return { value: year, label: `Calendar Year ${year}` };
    });
  };

  const generateFinancialYears = () => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5;
    const endYear = currentYear + 5;

    return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
      const year = startYear + i;
      return {
        value: `${year}-${year + 1}`,
        label: `Financial Year ${year}-${year + 1}`,
      };
    });
  };

  const handleYearChange = (selectedValue) => {
    // setSelectedYear(selectedValue);
    setDesignationData({
      ...designationData,
      year: selectedValue,
    });
  };

  const handleToggleChange = (event) => {
    setDesignationData({
      ...designationData,
      Active: event.target.checked,
    });
  };

  const getCurrentLocation = () => {
    setMapOpen(true);
  };

  const handleLocationSelect = (location) => {
    setDesignationData({
      ...designationData,
      latitude: location.lat,
      longitude: location.lng,
      latitudeStatus: "success",
      longitudeStatus: "success",
    });
    setMapOpen(false);
  };

  const handleChangeapprovalfor = (selected) => {
    setapprovalfor(selected);
  };

  const handleChangeapprovallevel = (selected) => {
    setapprovallevel(selected);
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "EditDesignation" && item.can_access
                ) &&
                (togglePage.edit || togglePage.view ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Approval Workflow Details
                      </MaterialTypography>
                    </Stack>

                    {display && (
                      <>
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                          {/* Uncomment this block to add delete functionality */}

                          <MaterialButton
                            variant="contained"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      </>
                    )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Approval Workflow Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                ))}
            </>
          }
        />
        <CardContent sx={{ minHeight: "55vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Approval for
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="approvalfor"
                  value={approval?.approvalfor}
                  onChange={handleDesignationDatachange}
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                  options={flowlist}
                  customStyles={{
                    optionPadding: 2,
                    optionMinWidth: 150,
                  }}
                  
                  // isLoading={isStateLoading}
                />
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Approval levels
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="approvallevel"
                  value={approval?.approvallevel}
                  onChange={handleDesignationDatachange}
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                  options={flowlevel}
                  customStyles={{
                    optionPadding: 2,
                    optionMinWidth: 150,
                  }}
                  // isLoading={isStateLoading}
                />
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {update && (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={onDiscardDesignation}
              >
                Discard
              </MaterialButton>

              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={!checkFields()}
                // onClick={onEditDesignationSubmit}
              >
                Update
              </MaterialButton>
            </>
          )}

          {!display && (
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              // onClick={handleAddDesignation}
            >
              Submit
            </MaterialButton>
          )}
        </MaterialBox>
        {
          <MaterialSnackbar
            color="success"
            icon={<NotificationsIcon />}
            title="Message"
            content="You have been submitted successfully"
            open={snackBar.Success}
            close={() =>
              setSnackBar({
                success: false,
              })
            }
          />
        }
      </Card>
    </DashboardLayout>
  );
};

export default AddWorkflow;
